import react from 'react';


const Footer: React.FC = () => {
    return (
        <footer className="w-100 position-absolute bottom-0 footer text-center d-flex align-items-center justify-content-center text-dark"><p className="p-0 m-0">MKS Sistemas © Todos os direitos reservados</p></footer>
    );
}

export default Footer;